export const crewManagementTableHeaders = [
	'Crew Member Name',
	'Employee Number',
	'Home Location',
	'Phone',
	'Mobility partner',
	'Group',
];

export const ERRORS = {
	homeBaseIsAbsent: 'Home location',
	phoneIsAbsent: 'Phone number',
	startTimeIsAbsent: 'Employment start date',
	drugTestExpirationTimeIsAbsent: 'Drug test expiration date',
	medicalCheckExpirationTimeIsAbsent: 'Medical check expiration date',
	driverLicenseExpirationTimeIsAbsent: 'Driver license expiration date',
	driverLicenseIsExpired: 'Driver license is expired',
	medicalCheckIsExpired: 'Medical check is expired',
	drugTestIsExpired: 'Drug test is expired',
	employmentTypeIsAbsent: 'Employment type',
};
